export const CLOCKLOAD_ROLES = {
  administrator: 'AP3733001-BRSA-CLOCKLOAD-ADM',
  it: 'AP3733001-BRSA-CLOCKLOAD-SCANIAIT',
  user: 'AP3733001-BRSA-CLOCKLOAD-USER',
} as const;

export const MANAGE_OPERATIONAL_AREAS_ROLES = [CLOCKLOAD_ROLES.administrator, CLOCKLOAD_ROLES.it];
